// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_FEED_POST = "P\u0159idej diskuzi";
export const COUNSELLING_IS_ARCHIVED = "Poradna je uzav\u0159ena";
export const FORUM_ADD_CONTEST = "P\u0159idej sout\u011b\u017e";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00ed ot\u00e1zku";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const FORUM_REPORTED_POSTS = "Nahl\u00e1\u0161en\u00e9 p\u0159\u00edsp\u011bvky";
export const FORUM_TOPIC_DELETE = "Vyma\u017e";
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const FORUM_TOPIC_SEO_WITH_AI = "Skontroluj diskuze s AI";
export const SEO_DESCRIPTION_FORUM_topic = "V\u0161echno na t\u00e9ma %(topic)s. Sd\u00edlej zku\u0161enosti, najdi u\u017eite\u010dn\u00e9 rady a zapoj se do diskuz\u00ed o tom, co t\u011b zaj\u00edm\u00e1.";
export const SEO_TITLE_FORUM = "Diskuze";
